import { Input as UiInput } from '@/components/ui/input'
import { cn } from '@/lib/utils'

import { inputVariants } from '../../configs/input.config'

import type { ComponentProps } from 'react'

export function Input({ className, ...props }: ComponentProps<typeof UiInput>) {
  return <UiInput className={cn(inputVariants(), className)} {...props} />
}
